import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { noop } from 'lodash';
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { useEffect, forwardRef } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import { Button } from '../';
var NOTICE_TIMEOUT = 10000;

function Snackbar(_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      _ref$onRemove = _ref.onRemove,
      onRemove = _ref$onRemove === void 0 ? noop : _ref$onRemove;
  useEffect(function () {
    var timeoutHandle = setTimeout(function () {
      onRemove();
    }, NOTICE_TIMEOUT);
    return function () {
      return clearTimeout(timeoutHandle);
    };
  }, []);
  var classes = classnames(className, 'components-snackbar');

  if (actions && actions.length > 1) {
    // we need to inform developers that snackbar only accepts 1 action
    // eslint-disable-next-line no-console
    console.warn('Snackbar can only have 1 action, use Notice if your message require many messages'); // return first element only while keeping it inside an array

    actions = [actions[0]];
  }

  return createElement("div", {
    ref: ref,
    className: classes,
    onClick: onRemove,
    tabIndex: "0",
    role: "button",
    onKeyPress: onRemove,
    label: __('Dismiss this notice')
  }, createElement("div", {
    className: "components-snackbar__content"
  }, children, actions.map(function (_ref2, index) {
    var label = _ref2.label,
        _onClick = _ref2.onClick,
        url = _ref2.url;
    return createElement(Button, {
      key: index,
      href: url,
      isTertiary: true,
      onClick: function onClick(event) {
        event.stopPropagation();

        if (_onClick) {
          _onClick(event);
        }
      },
      className: "components-snackbar__action"
    }, label);
  })));
}

export default forwardRef(Snackbar);
//# sourceMappingURL=index.js.map